import { isString } from 'lodash-es'
import {
  PersonWrapper,
  InfoWrapper,
  ProfileImage,
  Info,
  Name,
  Email,
  Extra,
} from './Styles'
import { PersonProps } from './'

const Person = ({
  name,
  email,
  image,
  small = false,
  style,
  extra,
  onClick,
  includeExtraInInfo,
}: PersonProps) => (
  <PersonWrapper style={style} onClick={onClick}>
    <InfoWrapper>
      {image && (
        <ProfileImage alt={name} src={image} name={name} small={small} />
      )}

      {(name || email || (includeExtraInInfo && extra)) && (
        <Info>
          {name && (
            <Name light={small} title={isString(name) ? name : undefined}>
              {name}
            </Name>
          )}

          {email && !small && (
            <Email title={isString(email) ? email : undefined}>{email}</Email>
          )}
          {includeExtraInInfo && extra && <Extra>{extra}</Extra>}
        </Info>
      )}
    </InfoWrapper>

    {extra && !includeExtraInInfo && <Extra>{extra}</Extra>}
  </PersonWrapper>
)

export default Person
